import Vue from 'vue';
import * as types from './types';
import { ProductTypePayload } from './types';
import { MutationTree } from 'vuex';
import { ProductHistory, ProductItem, ProductsState, SoftwareItem } from '@/types';
import { ProductType } from "@/constants/productTypes";

const mutations: MutationTree<ProductsState> = {

  [types.SET_PRODUCTS](state: ProductsState, payload: ProductTypePayload) {
    const key: (keyof ProductsState) = payload.type.stateField;
    const { content, totalElements } = payload.data;

    state[key].totalElements = totalElements;
    state[key].areAllItemsFetched = false;

    if (content) {
      state[key].items = content.map((item: any) => ({ productLink: item }));
    }
  },

  [types.SET_PRODUCTS_TYPE](state: ProductsState, type: ProductType) {
    const key: (keyof ProductsState) = type.stateField;
    state[key].type = type;
  },

  [types.SET_PRODUCT](state: ProductsState, payload: ProductTypePayload) {
    const key: (keyof ProductsState) = payload.type.stateField;
    state[key].areAllItemsFetched = true;

    const identifier = payload.data.productUuid || payload.data.uuid || payload.data.id;
    const items = state[key].items as ProductItem[];
    items.forEach((item, idx) => {
      if (item.productLink.endsWith(`/${identifier}`)) {
        const newItem = { ...item, ...payload.data };
        Vue.set(state[key].items, idx, newItem);
      }
    });
  },

  [types.SET_PRODUCT_HISTORY](state: ProductsState, { page, product }: { page: ProductHistory, product: ProductItem }) {
    const key: (keyof ProductsState) = product.model.category.stateField;
    const items = state[key].items as ProductItem[];
    const needle: ProductItem | undefined = items.find((item) => item.uuid === product.uuid);
    if (needle) {
      needle.history = page;
    }
  },

  [types.SET_PRODUCT_CONTRACTS](state: ProductsState, payload) {
    const key: (keyof ProductsState) = payload.type.stateField;
    const items = state[key].items as ProductItem[];
    const needle: ProductItem | undefined = items.find((item) => item.uuid === payload.productUuid);

    if (needle) {
      needle.contracts = payload.data;
    }
  },

  [types.DISPLAY_PRODUCT_HISTORY](state: ProductsState, product: ProductItem) {
    const key: (keyof ProductsState) = product.model.category.stateField;
    const items = state[key].items as ProductItem[];
    const needle: ProductItem | undefined = items.find((item) => item.uuid === product.uuid);
    if (needle) {
      needle.isHistoryDisplayed = !needle.isHistoryDisplayed;
    }
  },

  [types.TOGGLE_PRODUCT_TABLE](state: ProductsState, type) {
    const key: (keyof ProductsState) = type.stateField;
    state[key].isDisplayed = !state[key].isDisplayed;
  },

  [types.REFRESH_SOFTWARE](state: ProductsState, software: SoftwareItem) {
    const items = state.software.items as SoftwareItem[];
    const index = items.findIndex((item) => item.productUuid === software.productUuid);
    if (index !== -1) {
      Vue.set(items, index, software);
    }
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/products/mutations.ts